export class TMnReiniciarDatosSolicitudRequest {
    idenT_SOLICITUD: number = 0;
    iD_ESTADO_SOLICITUD: number = 0;
    idenT_USUARIO_MODIF: number = 0;
    descL_OBSERVACION: string | null = null;
    iD_ESTADO_RECONFIRMACION: number = 0;
    descL_COMENTARIO_RECONFIRMACION: string | null = null;
}
